import { enUS, enGB, enAU, enNZ } from "date-fns/locale";
/**
 * Supported date-fns locales.
 *
 * We explicitly write them here to avoid importing all locales from date-fns
 */
const dateFnsSupportedLocales = {
    "en-US": enUS,
    "en-GB": enGB,
    "en-AU": enAU,
    "en-NZ": enNZ,
};
const DEFAULT_DATE_FNS_LOCALE = enUS;
/**
 * Returns date-fns locale for given locale code.
 *
 * @param code - locale code from db (we store locale codes like en-US, en-GB, etc.)
 */
export const getDateFnsLocaleForCode = (code) => {
    const locale = dateFnsSupportedLocales[code];
    if (!locale) {
        return DEFAULT_DATE_FNS_LOCALE;
    }
    return locale;
};
export const US_LOCALE_CODE = "en-US";
export const GB_LOCALE_CODE = "en-GB";
export const AU_LOCALE_CODE = "en-AU";
export const NZ_LOCALE_CODE = "en-NZ";
const DEFAULT_NUTRITIONIX_LOCALE = "en_US";
const DEFAULT_NUTRITIONIX_BRANDED_REGION = 1;
export const getNutritionixBrandedRegionForLocale = (localeCode) => {
    switch (localeCode) {
        case US_LOCALE_CODE:
            return 1;
        case GB_LOCALE_CODE:
        case AU_LOCALE_CODE:
        case NZ_LOCALE_CODE:
            return 2;
        default:
            return DEFAULT_NUTRITIONIX_BRANDED_REGION;
    }
};
export const getNutritionixLocaleForLocale = (localeCode) => {
    switch (localeCode) {
        case US_LOCALE_CODE:
            return "en_US";
        case GB_LOCALE_CODE:
        case AU_LOCALE_CODE:
        case NZ_LOCALE_CODE:
            return "en_GB";
        default:
            return DEFAULT_NUTRITIONIX_LOCALE;
    }
};
//# sourceMappingURL=locales.js.map